import React from "react";
import ExtraGiftFieldsSection, {
  ExtraGiftFieldsState,
  ExtraGiftFieldsIntro,
} from "./extraGiftFieldsSection";
import { ICodeModel } from "../../../../types/services/DonorPerfectTypes";
import styles from "./styles.scss";

export interface ExtraGiftFieldsSettingsStepProps {
  extraGiftFields: ExtraGiftFieldsState;
  setExtraGiftFields: (fields: ExtraGiftFieldsState) => void;
  generalLedgers: ICodeModel[];
  campaigns: ICodeModel[];
  thankYouLetters: ICodeModel[];
  onValidationChange: (valid: boolean) => void;
  showOptionalHint?: boolean;
}

const ExtraGiftFieldsSettingsStep = ({
  extraGiftFields,
  setExtraGiftFields,
  generalLedgers,
  campaigns,
  thankYouLetters,
  onValidationChange,
  showOptionalHint = true,
}: ExtraGiftFieldsSettingsStepProps) => (
  <div>
    <ExtraGiftFieldsIntro
      className={styles.subtitleStep}
      showOptionalHint={showOptionalHint}
    />
    <ExtraGiftFieldsSection
      extraGiftFields={extraGiftFields}
      setExtraGiftFields={setExtraGiftFields}
      generalLedgers={generalLedgers}
      campaigns={campaigns}
      thankYouLetters={thankYouLetters}
      disabled={false}
      onValidationChange={onValidationChange}
      showSectionHeader={false}
    />
  </div>
);

export default ExtraGiftFieldsSettingsStep;
